import { render, staticRenderFns } from "./ListaJuegos.vue?vue&type=template&id=63e8e066&scoped=true&"
import script from "./ListaJuegos.vue?vue&type=script&lang=js&"
export * from "./ListaJuegos.vue?vue&type=script&lang=js&"
import style0 from "./ListaJuegos.vue?vue&type=style&index=0&id=63e8e066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8e066",
  null
  
)

export default component.exports